import React, { useContext } from "react";
import { Route, Switch } from "react-router-dom";
import GroupsList from "./components/GroupsList";
import { CourseContext } from "../Store";
import MembersList from "./components/MembersList";
import ReviewPage from "./components/ReviewPage";
import { useParams } from "react-router-dom";
import { activityIdAtom } from "./store";
import { Provider } from "jotai";

export default function GroupDetail() {
    const { basename } = useContext(CourseContext);
    const { activityId } = useParams();

    return (
        <Provider initialValues={[[activityIdAtom, activityId]] as any}>
            <Switch>
                <Route
                    path={`${basename}/group/detail/:activityId/members`}
                    component={MembersList}
                />
                <Route
                    path={`${basename}/group/detail/:activityId/review/:taskId/:groupId/:statusId/:homeworkId`}
                    component={ReviewPage}
                />
                <Route component={GroupsList} />
            </Switch>
        </Provider>
    );
}
